import { types as sdkTypes } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser, setCurrentUserHasOrders } from '../../ducks/user.duck';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const FETCH_LISTING_REQUEST = 'app/ScheduleConversationPage/FETCH_LISTING_REQUEST';
export const FETCH_LISTING_SUCCESS = 'app/ScheduleConversationPage/FETCH_LISTING_SUCCESS';
export const FETCH_LISTING_ERROR = 'app/ScheduleConversationPage/FETCH_LISTING_ERROR';

export const SCHEDULE_CONVERSATION_REQUEST = 'app/ScheduleConversationPage/SCHEDULE_CONVERSATION_REQUEST';
export const SCHEDULE_CONVERSATION_SUCCESS = 'app/ScheduleConversationPage/SCHEDULE_CONVERSATION_SUCCESS';
export const SCHEDULE_CONVERSATION_ERROR = 'app/ScheduleConversationPage/SCHEDULE_CONVERSATION_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchListingInProgress: false,
  fetchListingError: null,
  scheduleConversationInProgress: false,
  scheduleConversationError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LISTING_REQUEST:
      return { ...state, fetchListingInProgress: true, fetchListingError: null };
    case FETCH_LISTING_SUCCESS:
      return { ...state, fetchListingInProgress: false };
    case FETCH_LISTING_ERROR:
      return { ...state, fetchListingInProgress: false, fetchListingError: payload };

    case SCHEDULE_CONVERSATION_REQUEST:
      return { ...state, scheduleConversationInProgress: true, scheduleConversationError: null };
    case SCHEDULE_CONVERSATION_SUCCESS:
      return { ...state, scheduleConversationInProgress: false };
    case SCHEDULE_CONVERSATION_ERROR:
      return { ...state, scheduleConversationInProgress: false, scheduleConversationError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchListingRequest = () => ({ type: FETCH_LISTING_REQUEST });
export const fetchListingSuccess = () => ({ type: FETCH_LISTING_SUCCESS });
export const fetchListingError = error => ({
  type: FETCH_LISTING_ERROR,
  payload: error,
  error: true,
});

export const scheduleConversationRequest = () => ({ type: SCHEDULE_CONVERSATION_REQUEST });
export const scheduleConversationSuccess = () => ({ type: SCHEDULE_CONVERSATION_SUCCESS });
export const scheduleConversationError = error => ({
  type: SCHEDULE_CONVERSATION_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

export const fetchListing = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchListingRequest());

  return sdk.listings
    .show({
      id: listingId,
      include: ['author', 'author.profileImage', 'images'],
      'fields.image': [
        'variants.square-small',
        'variants.square-small2x',
        'variants.scaled-small',
        'variants.scaled-medium',
        'variants.scaled-large',
        'variants.scaled-xlarge',
        'variants.default',
      ],
    })
    .then(response => {
      const listingFields = getState().hostedConfig?.listing?.listingFields;
      const sanitizeConfig = { listingFields };
      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(fetchListingSuccess());
      return response;
    })
    .catch(e => {
      dispatch(fetchListingError(storableError(e)));
      throw e;
    });
};

export const scheduleConversation = (params, processAlias) => (dispatch, getState, sdk) => {
  dispatch(scheduleConversationRequest());

  const transitionName = 'transition/inquire';
  const bodyParams = {
    processAlias,
    transition: transitionName,
    params,
  };
  const queryParams = {
    include: ['booking', 'provider'],
    expand: true,
  };

  return sdk.transactions
    .initiate(bodyParams, queryParams)
    .then(response => {
      dispatch(scheduleConversationSuccess());
      dispatch(setCurrentUserHasOrders());
      return response;
    })
    .catch(e => {
      dispatch(scheduleConversationError(storableError(e)));
      throw e;
    });
};

// ================ Page load data ================ //

export const loadData = (params, search, config) => dispatch => {
  const listingId = new UUID(params.id);

  return Promise.all([
    dispatch(fetchListing(listingId)),
    dispatch(fetchCurrentUser()),
  ]);
};
